$(function () {

  // =========================================================================
  // Gestione video in dettaglio articolo
  // =========================================================================
  function PlayVideo() {
    $('.artVideo').height($('.cntArtImg').height());
    $('.artVideo').width($('.cntArtImg').width());
    $('.artVideo').removeClass('hidden');
    $('video', $('.artVideo')).trigger('play');
  }

  if ($('.artVideo').length > 0) {

    $('.details_video_gallery').bind('click', function (event) {
      PlayVideo();
      event.preventDefault();
    });

    $('video', $('.artVideo')).bind('ended', function () {
      $('.artVideo').addClass('hidden');
      $('.default_img').trigger('click');
    });

    $('video', $('.artVideo')).bind('abort', function () {
      $('.artVideo').addClass('hidden');
      $('.default_img').trigger('click');
    });
  }

  // =========================================================================
  // Gestione incisioni
  // =========================================================================
  $('#incisione').on('change', function () {

    // Se è stata selezionata un incisione
    if ($('#incisione').val() > 0) {

      // Se l'incisione è fronte retro
      if (parseInt($('#incisione').val(), 10) === 162338) {
        $('#incisione_fr_container').removeClass('hidden'); // Mostro i campi fronte retro
        $('#incisione_descr_container').addClass('hidden'); // Nascondo il campo incisione generica se visibile

      } else {
        $('#incisione_fr_container').addClass('hidden'); // Nascondo il campo fronte retro se visibile
        $('#incisione_descr_container').removeClass('hidden'); // Mostro il campo incisione

        // Prendo il valore di lunghezza massima associato all'incisione selezionata
        // e lo passo all'input dove inserire il testo da incidere
        $('#incisione_descr').attr('maxlength', $('#incisione').children(':selected').attr('data-maxlen'));

      }
    } else {
      $('#incisione_fr_container').addClass('hidden');
      $('#incisione_descr_container').addClass('hidden');
      $('#incisione_descr').attr('value', '');
    }
  });

  // Gestione incisione fronte retro
  function mergeEngravingText(fronte, retro, $res) {
    $res.val(`Fronte: ${fronte} - Retro: ${retro}`);
  }

  $('#incisione_fronte').on('keyup', function () {
    mergeEngravingText($('#incisione_fronte').val(), $('#incisione_retro').val(), $('#incisione_descr'));
  });
  $('#incisione_retro').on('keyup', function () {
    mergeEngravingText($('#incisione_fronte').val(), $('#incisione_retro').val(), $('#incisione_descr'));
  });


  // =========================================================================
  // Gestione visualizzazione immagine
  // =========================================================================
  // $('.details_image_gallery').click(function(event){
  // if ($('.artVideo').is(':visible'))
  // {
  // $('video',$('.artVideo')).trigger('pause');
  // $('video',$('.artVideo'))[0].currentTime=0;
  // $('.artVideo').addClass('hidden');


  // }
  // $("#PdsDetailsImg").attr('src',$(this).attr('rel'));
  // $("#PdsDetailsImg").parent('a').attr('href',$(this).attr('href'));
  // event.preventDefault();
  // });
});


if ($('#dettaglio-articolo').length) {
  (function () {

    $('.crossup-item').on('click', function () {

      $(this).toggleClass('selected');

      const $fCheck = $('.f-check', this);
      const $rCheck = $('.r-check', this);

      $fCheck.toggleClass('selected');

      if ($rCheck.prop('checked')) {
        $rCheck.prop('checked', false);
      } else {
        $rCheck.prop('checked', true);
      }
    });
  }());
}

let ofs = 100;
if ($(window).width() > 768) { ofs = 200; }
$('.anchor-usato').on('click', function () {
  $('html, body').animate({
    scrollTop: $('#ur-info').offset().top - ofs,
  }, 500);
});


/**
 * Funzione che mostra il nome inserito nel campo di personalizzazione
 * usato principalmente per collane e bracciali con nome
 */
$('#personalizza-nome').on('keyup', function () {
  if ($('#personalizza-nome').val()) {
    $('.text-container').removeClass('hidden');
    $('.custom-text').html($('#personalizza-nome').val());
  } else {
    $('.text-container').addClass('hidden');
  }
});


/**
 * Funzione che mostra l'anteprima del nome sottoforma di bandierine nautiche
 * da utilizzare con il relativo tag associato ai bracciali arcadia
 */
(function () {
  if ($('#details-custom-field').length) {
    // Imposto un counter per evitare che ogni volta che viene premuto
    // un pulsante si riavvii la routine se le lettere non sono variate
    let counter = 0;

    // Imposto le costanti per le immagini delle bandierine nautiche
    const URL = '../images/bandiere_nautiche/';
    const NAUTICAL_FLAGS = {
      a: `${URL}lettera_A.jpg`,
      b: `${URL}lettera_B.jpg`,
      c: `${URL}lettera_C.jpg`,
      d: `${URL}lettera_D.jpg`,
      e: `${URL}lettera_E.jpg`,
      f: `${URL}lettera_F.jpg`,
      g: `${URL}lettera_G.jpg`,
      h: `${URL}lettera_H.jpg`,
      i: `${URL}lettera_I.jpg`,
      j: `${URL}lettera_J.jpg`,
      k: `${URL}lettera_K.jpg`,
      l: `${URL}lettera_L.jpg`,
      m: `${URL}lettera_M.jpg`,
      n: `${URL}lettera_N.jpg`,
      o: `${URL}lettera_O.jpg`,
      p: `${URL}lettera_P.jpg`,
      q: `${URL}lettera_Q.jpg`,
      r: `${URL}lettera_R.jpg`,
      s: `${URL}lettera_S.jpg`,
      t: `${URL}lettera_T.jpg`,
      u: `${URL}lettera_U.jpg`,
      v: `${URL}lettera_V.jpg`,
      w: `${URL}lettera_W.jpg`,
      x: `${URL}lettera_X.jpg`,
      y: `${URL}lettera_Y.jpg`,
      z: `${URL}lettera_Z.jpg`,
    };

    $('#personalizza-nome').on('keyup', function () {

      const valore = $('#personalizza-nome').val().toLowerCase();

      const valoriErrati = valore.replace(/[a-z]/g, '');

      // Se ci sono dei valori errati resetto il counter e visualizzo un messaggio di errore
      if (valoriErrati) {
        counter = 0;
        const errorMsg = '<div>E\' possibile inserire solo lettere, non sono ammessi numeri o simboli</div>';
        $('#nautical-flag-preview').children('div').replaceWith(errorMsg);

      } else {

        const nome = valore.replace(/[^a-z]/g, '').split('');

        if (nome.length !== counter) {
          counter = nome.length;
          const nautical = document.createElement('div');
          nome.forEach((el) => {
            const img = document.createElement('img');
            img.src = NAUTICAL_FLAGS[el];
            nautical.appendChild(img);
          });
          $('#nautical-flag-preview').children('div').replaceWith(nautical);
        }
      }
    });
  }
}());


/**
 * Funzione che mostra uno sticky add-to-cart a fondo pagina da mobile
 */
(function () {

  const addToCart = document.getElementById('add-to-cart');
  const addToCartMobile = document.getElementById('add-to-cart-mobile');
  let scrollTimer;

  if (addToCart && addToCartMobile) {

    window.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        if (addToCart.getBoundingClientRect().top > -100) {
          addToCartMobile.classList.remove('visible');
        } else {
          addToCartMobile.classList.add('visible');
        }
      }, 50);
    }, false);

    addToCartMobile.addEventListener('click', () => addToCart.click());
  }
}());


/**
 * Funzione che gestisce la visualizzazione del coupon sconto
 */
(function () {
  const message = document.querySelector('.message');
  const coupon = document.querySelector('.coupon');
  const copyIcon = document.querySelector('.fa-clone');

  if (copyIcon) {
    copyIcon.addEventListener('click', () => {
      navigator.clipboard.writeText(document.querySelector('.coupon-code').innerText)
        // eslint-disable-next-line no-alert
        .then(() => alert('Codice copiato negli appunti'));
    });
  }

  if (message) {
    message.addEventListener('click', () => {
      message.classList.add('hidden');
      coupon.classList.remove('hidden');
    });
  }
}());
